import { useModals } from '@frontend/modal';
import { resetSelect, useAccountRepository } from '@frontend/repository';
import { UserClient } from '@frontend/user/api';
import { IUser } from '@frontend/user/types';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../redux/store';

export const useContacts = () => {
    const {
        currentAccount,
        store: { availableAccountsInfo }
    } = useAccountRepository();
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState<string>('personal_contacts');
    const { openModal, closeTopModal } = useModals();
    const navigate = useNavigate();
    const location = useLocation();
    const listState = useAppSelector((state) => state.lists);

    const uniqueIdentifier = useMemo(() => {
        return availableAccountsInfo.find((acc) => acc.id === currentAccount)?.user_identifier_field;
    }, [availableAccountsInfo, currentAccount]);

    const selected = listState[`${activeTab === 'personal_contacts' ? 'personal' : 'corporate'}-contacts-list`]?.selected;

    const onDelete = () => {
        UserClient.deleteUsers(selected?.map((u) => u.id) ?? []);
        closeTopModal();
        dispatch(
            resetSelect({
                listId: `${activeTab === 'personal_contacts' ? 'personal' : 'corporate'}-contacts-list`
            })
        );
    };

    return {
        currentAccount,
        activeTab,
        setActiveTab,
        dispatch,
        openModal,
        closeTopModal,
        onDelete,
        navigate,
        location,
        uniqueIdentifier,
        selected: selected?.length > 0 ? (selected as IUser[]) : undefined
    };
};
